import "element-plus/theme-chalk/index.css";

import App from "@/App.vue";
import ElementPlus from "element-plus";
import { configService } from "@/services/config-service";
import { createApp, type App as VueApp } from "vue";
import { initPendoIfEnabled } from "@/plugins/n9PendoConfigurationPlugin";
import { initSentry } from "@/plugins/n9SentryConfigurationPlugin";
import router from "@/router";
import store from "@/store";

const configPath = `${document.baseURI}config.json?t=${Date.now()}`;
fetch(configPath)
  .then((response) => response.json())
  .then((config) => {
    configService.init(config);

    const app = createApp(App);
    app.use(store).use(router).use(ElementPlus).mount("#app");

    return app;
  })
  .then((app: VueApp) => {
    initSentry(app, {
      enabled: configService.isSentryEnabled,
      dsn: configService.sentryDsn,
      environment: configService.environment,
      version: configService.version,
      tracesSampleRate: Number(configService.tracesSampleRate),
    });
    initPendoIfEnabled({
      enabled: configService.isPendoEnabled,
      apiKey: configService.pendoApiKey,
    });
  });
